export default __webpack_public_path__ + "static/media/Frame_197.083dea2f.jpg";